import { motion } from "framer-motion";
import { EASE } from "@/lib/motion";

export default function IntroRibbon() {
  return (
    <motion.div
      className="intro-ribbon"
      initial={{ y: 12 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5, ease: EASE }}
      data-testid="intro-ribbon"
    >
      <p>
        Jij maakt de keuzes.
        <br />
        <strong>Wij maken de ruimte.</strong>
      </p>
      <p>
        Bewaren, hergebruiken of afvoeren.
        <br />
        Alles begint met een duidelijke afspraak.
      </p>
      <span>LAARBEEK &amp; OMGEVING</span>
    </motion.div>
  );
}
